<template>
  <div class="video-modal" :class="{ 'is-init': isInit }">
    <VideoPlayer class="video" :options="playerOptions" />
    <!-- <div class="video">
      <iframe
        style="width: 100%; height: 100%"
        src="https://www.youtube.com/embed/LKkP74ABS1U?autoplay=1&mute=1&playsinline=1"
        title="Shop on Taobao by Acbuy"
        frameborder="0"
        allow="accelerometer; autoplay=1; mute=1; clipboard-write; encrypted-media; gyroscope; picture-in-picture;"
        referrerpolicy="strict-origin-when-cross-origin"
        allowfullscreen
      ></iframe>
    </div> -->

    <el-icon v-if="closeVisible" class="close-icon" @click="$emit('close')">
      <CircleClose />
    </el-icon>
  </div>
</template>

<script setup>
import 'video.js/dist/video-js.css'
import { defineEmits, defineProps, onMounted, ref } from 'vue'
import { VideoPlayer } from 'vue-video-player'
defineProps({
  isInit: {
    type: Boolean,
    default: true,
  },
})
const $emit = defineEmits(['close'])
const closeVisible = ref(false)
const playerOptions = {
  sources: [
    {
      src: 'https://www.acbuy.com/video/shop-taobao.webm',
      type: 'video/webm',
    },
  ],
  autoplay: false,
  muted: true,
  controls: true,
}

onMounted(() => {
  setTimeout(() => {
    closeVisible.value = true
  }, 2000)
})
</script>

<style scoped lang="scss">
.video-modal {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background-color: var(--background-disabled-btn);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;

  &.is-init {
    width: 27.8125vw;
    height: 15.625vw;
    left: initial;
    top: initial;
    bottom: 100px;
    right: 80px;

    .video {
      width: 100%;
      height: 100%;
    }

    .close-icon {
      top: 10px;
      right: 10px;
    }
  }

  :deep(.v-video-player) {
    padding: 0 !important;

    .vjs-big-play-button {
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .video {
    width: 50vw;
    height: 50vh;
    position: relative;
    z-index: 10;
  }

  .close-icon {
    position: absolute;
    top: 25.6vh;
    right: 25.4vw;
    font-size: 24px;
    color: var(--white-color-1-light);
    cursor: pointer;
    z-index: 100;
  }
}
</style>
